import { call, put } from "redux-saga/effects";
import api from "../../services/api";

import Constants from "expo-constants";

import { Creators as ProfileActions } from "../ducks/profile";

const API_KEY: string = "053219f8-29ca7ed0-b4c669d8-e9b48f53";

export function* searchProfile(action) {
  try {
    const responseId = yield call(
      api.get,
      `/lookup?username=${action.payload.epicName}`,
      {
        headers: {
          Authorization: API_KEY,
        },
      }
    );

    console.log(responseId);

    const responseStats = yield call(
      api.get,
      `/stats?account=${responseId.data.account_id}`,
      {
        headers: {
          Authorization: API_KEY,
        },
      }
    );

    yield put(ProfileActions.searchProfileSuccess(responseStats.data));
  } catch (err) {
    yield put(ProfileActions.searchProfileFailure("Jogador não encontrado"));
  }
}
